import React, { FC } from "react";
import memoize from "utils/memoize";
import {
  RHFormConsumerTextField,
  RHFormConsumerTextFieldProps
} from "component-rh-text-field/RHFormConsumerTextField";

export const AddressLine2Field: FC<RHFormConsumerTextFieldProps> = ({
  value,
  ...props
}) => (
  <RHFormConsumerTextField
    defaultValue=""
    autoComplete="address-line2"
    name={"addressLine2"}
    fullWidth
    label={props.label || "Apt., Floor, Suite, etc. (optional)"}
    {...props}
  />
);

export default memoize(AddressLine2Field);
